import { ADVENTURE_GREEN, ELEMENT_GRAY, NIGHTINGALE_BLACK, RIOJA_RED, SUNSHINE_YELLOW } from '../colors';
const COLORS = {
  default: ELEMENT_GRAY,
  info: ELEMENT_GRAY,
  alert: RIOJA_RED,
  alarm: RIOJA_RED,
  error: RIOJA_RED,
  success: ADVENTURE_GREEN,
  primary: ADVENTURE_GREEN,
  secondary: NIGHTINGALE_BLACK,
  warning: SUNSHINE_YELLOW
};
export const getVariantColor = (variant = 'default') => COLORS[variant] || COLORS.default;
export const getVariantName = props => {
  const {
    isSecondary,
    isPrimary,
    isAlarm,
    isAlert,
    isError,
    isInfo,
    isSuccess,
    isWarning,
    isDark,
    variant
  } = props;
  if (isPrimary) return 'primary';
  if (isSecondary) return 'secondary';
  if (isAlarm) return 'alarm';
  if (isAlert) return 'alert';
  if (isError) return 'error';
  if (isInfo) return 'info';
  if (isSuccess) return 'success';
  if (isWarning) return 'warning';
  if (isDark) return 'dark';
  return variant;
};